<template>
  <el-date-picker
      v-bind="$attrs"
      v-on="$listeners"
      v-model="time"
      @change="handleChangeTime"
      :type="type"
      :value-format="valueFormat"
      :default-time="['00:00:00', '23:59:59']"
      :range-separator="$t('至')"
      :start-placeholder="$t('开始日期')"
      :end-placeholder="$t('结束日期')">
  </el-date-picker>
</template>

<script>
export default {
  name: "DateTimeRangePicker",
  props: {
    startTime: {
      type: [String, Number],
      default: ""
    },
    endTime: {
      type: [String, Number],
      default: ""
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss"
    },
    type: {
      type: String,
      default: "datetimerange"
    }
  },
  data() {
    return {
      time: [],
    }
  },
  methods: {
    handleChangeTime(time) {
      time = time ? time : [];
      let startTime = time[0];
      let endTime = time[1];
      this.$emit("change", time);
      this.$emit("update:startTime", startTime);
      this.$emit("update:endTime", endTime);
    }
  },
  watch: {
    startTime: {
      handler(newVal) {
        const start = newVal || null;
        const end = this.endTime || null;
        this.time = start && end ? [start, end] : [];
      },
      immediate: true,
    },
    endTime(newVal) {
      const start = this.startTime || null;
      const end = newVal || null;
      this.time = start && end ? [start, end] : [];
    },
  }
}
</script>

<style scoped>

</style>
